import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'
import { pxToRem } from '#commerce/utils/pxToRem'

export default {
  brandClasses: {
    container: 'space-y-1 <md:bg-transparent md:py-10 px-2',
    containerWrapper: 'px-4 <md:!my-10'
  },
  brandStyles: {
    containerFullHeight: () => (height, fallback) => ({
      h: {
        sm: `calc(100svh - ${height ? pxToRem(height) : fallback?.sm || 0})`,
        lg: `calc(100svh - ${height ? pxToRem(height) : fallback?.lg || 0})`
      }
    })
  }
} satisfies RecursivePartial<CMSConfig['imageBanner']>
